export default class GlobaleSlider {
  constructor(component) {
    this.dom = {
      $component: component,
      $globaleSlider: component,
      $globaleSliderBtn: document.querySelector('.js-globaleBtn'),
      $globaleSliderToggle: document.querySelectorAll('.js-globaleSliderToggle'),
      $globaleSliderUnderlay: document.querySelector('.js-globaleFormUnderlay'),
      $navigation: document.querySelector('.js-navigation'),
    }
    this.state = {
      globaleSliderOpen: false,
      globaleSliderOpenClass: 'openGlobaleSlider',
      underlayActiveClass: 'isActive',
    }
    this.globaleSliderToggleHandler = this.globaleSliderToggle.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom } = this
    dom.$globaleSliderToggle.forEach($toggle => $toggle.addEventListener('click', this.globaleSliderToggleHandler))
  }

  globaleSliderToggle() {
    const { dom, state } = this
    // Import the AccountSlider class
    const accountSlider = window.theme.AccountSlider

    if (state.globaleSliderOpen) {
      dom.$globaleSlider.setAttribute('aria-hidden', 'true')
      dom.$globaleSlider.setAttribute('aria-expanded', 'false')
      dom.$navigation.classList.remove(state.globaleSliderOpenClass)
      dom.$globaleSliderBtn.classList.remove(state.globaleSliderOpenClass)
      dom.$globaleSliderUnderlay.classList.remove(state.underlayActiveClass)
      state.globaleSliderOpen = false
    } else {
      // Close the AccountSlider if it's open
      if (accountSlider && accountSlider.state.accountSliderOpen) {
        accountSlider.accountSliderToggle()
      }
      dom.$globaleSlider.setAttribute('aria-hidden', 'false')
      dom.$globaleSlider.setAttribute('aria-expanded', 'true')
      dom.$navigation.classList.add(state.globaleSliderOpenClass)
      dom.$globaleSliderBtn.classList.add(state.globaleSliderOpenClass)
      dom.$globaleSliderUnderlay.classList.add(state.underlayActiveClass)
      state.globaleSliderOpen = true
    }

  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.GlobaleSlider = this
  }
}
